<template>
  <div>
    <side-bar :title="sideBarActionEdit ? 'Edytuj zgodę' : 'Dodaj zgodę'" width='large' :visible="sideBarVisable">
      <b-container fluid class="px-4 py-3">
        <b-row>
          <b-col>
            <vs-input
              label-placeholder="Nazwa"
              v-model="agreement.name"
              class="w-full mt-8"
            />
            <field-error :errorsBag="formErrors" fieldName="name"/>
            <vs-textarea
              label="Treść skrócona"
              v-model="agreement.short_content"
              class="w-full mt-8"
            />
            <field-error :errorsBag="formErrors" fieldName="short_content"/>
            <vs-textarea
              label="Treść"
              v-model="agreement.full_content"
              class="w-full mt-8"
            />
            <field-error :errorsBag="formErrors" fieldName="full_content"/>
            <vs-checkbox v-model="agreement.is_required" class="mt-8">Zgoda wymagana</vs-checkbox>
            <field-error :errorsBag="formErrors" fieldName="is_required"/>
          </b-col>
        </b-row>
        <b-row class="mt-8">
          <b-col cols="3">
            <vs-button type="filled round"  icon-pack="feather" :icon="sideBarActionEdit ? 'icon-save' : 'icon-plus'"
                       @click="handleSideBarAction">{{ sideBarActionEdit ? 'Zapisz' : 'Dodaj' }}
            </vs-button>
          </b-col>
          <b-col>
            <vs-button type="border round" block @click="closeSideBar" icon="close">Anuluj</vs-button>
          </b-col>
        </b-row>
      </b-container>
    </side-bar>
    <vx-card>
      <b-container fluid>
        <b-row class="my-6">
          <b-col><h4>Lista zgód</h4></b-col>
          <b-col>
            <vs-button type="filled round" icon-pack="feather" icon="icon-plus"
                       class="float-right" @click="openAddSideBar">Dodaj zgodę</vs-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              hover
              :items="agreements"
              :fields="agreementFields"
              select-mode="single"
              selectable
              @row-selected="onRowSelected"
            >
              <template v-slot:cell(is_required)="data">
                <vs-checkbox disabled v-model="data.item.is_required"></vs-checkbox>
              </template>
              <template v-slot:cell(uuid)="data">
                <div class="d-flex">
                  <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-trash"
                             @click="deleteAgreement(data.item.uuid)"></vs-button>
                  <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-edit-2"
                             @click="openEditSideBar(data.item.name, data.item.short_content, data.item.full_content, data.item.is_required, data.item.uuid)"></vs-button>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>
    </vx-card>
  </div>
</template>

<script>
import notification from './../../notification'
import SideBar from './../../components/wod/SideBar'
import FieldError from './../../components/wod/forms/FieldError'
import {fetchAgreements, manageAgreement, createAgreement} from './../../mixins/agreements/agreementsMixin'

export default {
  mixins: [fetchAgreements, manageAgreement, createAgreement],
  name: 'Agreements',
  components: {
    'side-bar': SideBar,
    'field-error': FieldError
  },
  data() {
    return {
      sideBarActionEdit: false, // true if sidebar action is ADD, false if EDIT
      sideBarVisable: false,
      formErrors: {},
      agreementFields: [
        {key: 'name', label: 'Nazwa zgody', sortable: true},
        {key: 'short_content', label: 'Skrócona treść', sortable: true},
        {key: 'is_required', label: 'Zgoda wymagana'},
        {key: 'uuid', label: 'Akcje'}
      ]
    }
  },
  methods: {
    openEditSideBar(name, shortContent, fullContent, isRequired, uuid) {
      this.setUpdateForm(name, shortContent, fullContent, isRequired, uuid)
      this.sideBarActionEdit = true
      this.sideBarVisable = true
    },
    openAddSideBar() {
      this.sideBarActionEdit = false
      this.sideBarVisable = true
    },
    closeSideBar() {
      this.sideBarVisable = false
      this.clearFormErrors()
    },
    handleSideBarAction() {
      this.sideBarActionEdit ? this.updateAgreement() : this.createAgreement()
    },
    clearFormErrors() {
      this.formErrors = {}
    },
    setUpdateForm(name, short_content, full_content, is_required, uuid) {
      this.agreement.name = name,
        this.agreement.short_content = short_content,
        this.agreement.full_content = full_content,
        this.agreement.is_required = is_required,
        this.agreement.uuid = uuid
    },
    onRowSelected(items) {
      this.$router.push({name: 'agreements_single', params: {uuid: items[0].uuid}})
    }
  }
}
</script>

<style scoped>

</style>
